module.exports = __webpack_public_path__ + "static/media/06-interview.fd072ef4.png";